export const CustomReportsI18n = {
  noLinks: "No Links",
  linkedSubmittals: "Linked Submittals",
  linkedActivities: "Linked Activities",
  includesDeliveredMaterials: "Includes Delivered Materials",
  doesNotIncludeDeliveredMaterials: "Does Not Include Delivered Materials",
  materialDescription: "Material Description",
  submittalDescription: "Submittal Description",
  finalResponse: "Final Response"
};

export const LINKED_SUBMITTALS_KEY = "linked_submittals";
export const LINKED_ACTIVITIES_KEY = "linked_activities";

export const MATERIAL_TITLE_KEY = "title";
export const MATERIAL_DESCRIPTION_KEY = "description";
export const LINKED_SUBMITTAL_TITLE_KEY = `${LINKED_SUBMITTALS_KEY}__title`;
export const LINKED_SUBMITTAL_DESCRIPTION_KEY = `${LINKED_SUBMITTALS_KEY}__description`;
export const LINKED_SUBMITTAL_FINAL_RESPONSE_KEY = `${LINKED_SUBMITTALS_KEY}__final_response`;
export const CUSTOM_FIELD_PREFIX = "_custom_fields.";
